/* eslint-disable import/no-named-as-default */
/* eslint-disable no-shadow */
import React from "react";
import PropTypes from "prop-types";
import DesktopDateFilter from "./DateFilters/DesktopDateFilter";
import MobileDateFilter from "./DateFilters/MobileDateFilter";

export const DateFilter = (props) => {
  const { hubAdminPresent } = props;

  if (window.innerWidth < 767) {
    return <MobileDateFilter hubAdminPresent={hubAdminPresent} />;
  }
  return <DesktopDateFilter hubAdminPresent={hubAdminPresent} />;
};

DateFilter.propTypes = {
  hubAdminPresent: PropTypes.bool.isRequired,
};

export default DateFilter;
